package analytics

class ScreenTracker(
    private val analytics: Analytics,
) {
    private var lastName: String? = null

    fun track(name: String, properties: Map<String, Any?> = emptyMap()) {
        if (name.isBlank() || name == lastName) return
        lastName = name
        analytics.screen(name, properties)
    }
}
